<ng-container *ngIf="card">
    <a *ngIf="card.aliasNo === favorite && card.message != ''" 
        class="pendingCharge" 
        style="color: rgb(255, 255, 255);" 
        (click)="onClick_PendingChargeDetail(card.message)"
    >
        &nbsp;&nbsp;!&nbsp;&nbsp;
    </a>
</ng-container>